<template>
  <div class="tinto-page">
    <Loading :isActive="loading" />

    <TintometricoVincularEanModal
      name="coranteForm"
      :subtitle="editForm.nome"
      :ean-atual="editForm.ean"
      :endpoint="`/admin/tintometrico/corante/${editForm.id}`"
      @saved="load"
    />

    <!-- ===== FILTERS ===== -->
    <div class="tinto-filters">
      <CRow>
        <CCol md="6">
          <input class="form-control" v-model="filtros.termo" placeholder="Buscar por nome ou código..." @keyup.enter="load()" />
        </CCol>
        <CCol md="4">
          <select class="form-control" v-model="filtros.fabricanteId" @change="load()">
            <option value="">Todos os fabricantes</option>
            <option v-for="(n,id) in fabricantes" :key="id" :value="id">{{ n }}</option>
          </select>
        </CCol>
        <CCol md="2">
          <button class="button button-primary" @click="load()">Buscar</button>
        </CCol>
      </CRow>
    </div>

    <!-- ===== TABLE ===== -->
    <div class="tinto-table-wrap">
      <table class="tinto-table">
        <thead><tr>
          <th style="width:50px">ID</th>
          <th style="width:280px" class="tinto-sortable" :class="{'is-active': sort.by==='nome'}" @click="sortBy('nome')">
            Nome<fa-icon :icon="sort.by==='nome' ? (sort.dir==='asc' ? 'arrow-up' : 'arrow-down') : 'arrow-down'" class="sort-icon" />
          </th>
          <th style="width:140px" class="tinto-sortable" :class="{'is-active': sort.by==='id_externo'}" @click="sortBy('id_externo')">
            Código Externo<fa-icon :icon="sort.by==='id_externo' ? (sort.dir==='asc' ? 'arrow-up' : 'arrow-down') : 'arrow-down'" class="sort-icon" />
          </th>
          <th style="width:110px;text-align:right" class="tinto-sortable" :class="{'is-active': sort.by==='volume_ml'}" @click="sortBy('volume_ml')">
            Volume (ml)<fa-icon :icon="sort.by==='volume_ml' ? (sort.dir==='asc' ? 'arrow-up' : 'arrow-down') : 'arrow-down'" class="sort-icon" />
          </th>
          <th style="width:130px">EAN</th>
          <th style="width:110px">Fabricante</th>
          <th style="width:50px"></th>
        </tr></thead>
        <tbody>
          <tr v-if="items.length === 0"><td colspan="7" class="tinto-table__empty">Nenhum corante encontrado</td></tr>
          <tr v-for="r in items" :key="r.id">
            <td>{{ r.id }}</td>
            <td class="tinto-table__primary">{{ r.nome }}</td>
            <td>{{ r.idExterno }}</td>
            <td style="text-align:right">{{ r.volumeMl }}</td>
            <td><span v-if="r.ean">{{ r.ean }}</span><span v-else class="tinto-table__muted">—</span></td>
            <td>{{ r.fabricanteNome }}</td>
            <td>
              <button class="button button-primary" @click="openEdit(r)" title="Vincular EAN">
                <fa-icon icon="pencil-alt" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="tinto-pagination" v-if="paginator.last_page > 1">
      <pagination :data="paginator" :limit="5" @pagination-change-page="load" />
    </div>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import TintometricoVincularEanModal from "./TintometricoVincularEanModal.vue";
import listagemMixin from "./listagemMixin";

export default {
  name: "tintometrico-corante",
  components: { Loading, TintometricoVincularEanModal },
  mixins: [listagemMixin],
  props: ['fabricantes'],

  data() {
    return {
      listagemEndpoint: '/admin/tintometrico/corante',
      sort: { by: 'nome', dir: 'asc' },
      filtros: { termo: '', fabricanteId: '' },
      editForm: { id: null, nome: '', ean: '' },
    };
  },

  methods: {
    openEdit(corante) {
      this.editForm = {
        id: corante.id,
        nome: corante.nome,
        ean: corante.ean,
      };
      this.$modal.show('coranteForm');
    },
  },
};
</script>
